import React, { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import { colors } from 'src/theme/colors'
import { MultipleWrapper } from './styles'

function GridSkeletonComponent() {
  return (
    <MultipleWrapper>
      <div className="content">
        <Skeleton width={250} height={200} baseColor={colors.palette.neutral500} />
        <Skeleton width={250} height={200} baseColor={colors.palette.neutral500} />
        <Skeleton width={250} height={200} baseColor={colors.palette.neutral500} />
        <Skeleton width={250} height={200} baseColor={colors.palette.neutral500} />
        <Skeleton width={250} height={200} baseColor={colors.palette.neutral500} />
        <Skeleton width={250} height={200} baseColor={colors.palette.neutral500} />
      </div>
    </MultipleWrapper>
  )
}

export const GridSkeleton = memo(GridSkeletonComponent)
